import { biCardSubtitle } from '@euler/app/components/message/widgets/bi-visualization/functions/biCardSubtitle';
import { biVizIcon } from '@euler/app/components/message/widgets/bi-visualization/functions/biVizIcon';
import { useBiViewMode } from '@euler/app/components/message/widgets/bi-visualization/functions/useBiViewMode';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { BiTag } from '@euler/app/flows/bi-dashboards/components/ui/BiTag';
import { CardBody } from '@euler/app/flows/bi-dashboards/dashboard/card/CardBody';
import { CardFrame } from '@euler/app/flows/bi-dashboards/dashboard/card/CardFrame';
import {
  BiCardKind,
  biCardKind,
} from '@euler/app/flows/bi-dashboards/functions/biCardKind';
import {
  biRowsHeight,
  kBiCardKindRows,
} from '@euler/app/flows/bi-dashboards/functions/biGridLayout';
import { BiDateFilterUse } from '@euler/model/bi/dashboard';
import { BiPalette, BiTitleAlign } from '@euler/model/bi/viz';
import { CalendarX } from 'lucide-react-native';
import { memo } from 'react';
import { BiGalleryDashboardCard } from '../../functions/biGalleryTypes';

const noop = () => undefined;

/**
 * A fixture card in the dashboard's chrome, at a dashboard card's height,
 * with its chart / table toggle; nothing loads, so retry does nothing.
 */
export const DashboardVariantCard = memo(
  ({ card, palette }: { card: BiGalleryDashboardCard; palette: BiPalette }) => {
    const { viz, data } = card;
    const ready = data.kind === 'ready' ? data : null;
    const { view, toggle } = useBiViewMode(viz, ready?.result.current ?? null);
    const kind = biCardKind(viz);
    const height = biRowsHeight(card.rows ?? kBiCardKindRows[kind]);
    // As on a dashboard: shorter than a KPI's own height tightens the chrome.
    const compact = height < biRowsHeight(kBiCardKindRows[BiCardKind.Kpi]);
    return (
      <CardFrame
        icon={biVizIcon(viz.type)}
        title={card.title}
        titleHidden={viz.style?.title?.show === false}
        titleCentered={viz.style?.title?.align === BiTitleAlign.Center}
        subtitle={ready ? biCardSubtitle(viz, ready.result.current) : null}
        badge={
          ready?.dateFilter === BiDateFilterUse.Ignored ? (
            <BiTag
              text="未应用日期筛选"
              color={aiColors.amber}
              icon={CalendarX}
            />
          ) : null
        }
        trailing={toggle}
        height={height}
        compact={compact}
      >
        <CardBody
          state={data}
          viz={viz}
          kind={kind}
          compact={compact}
          view={view}
          palette={palette}
          onRetry={noop}
        />
      </CardFrame>
    );
  },
);
